<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row" v-if="loaded">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('SiteOrderNumber') },
                { title: $t('DischargePermissionId') },
                { title: $t('DraftOrderId') },
                { title: $t('OrderId') },
                { title: $t('UserName') },
                { title: $t('Description') },
                { title: $t('Date') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 12%">
                  {{ row.basketId }}
                </td>
                <td style="width: 14%">
                  <span v-if="row.dischargePermissionId">{{
                    row.dischargePermissionId
                  }}</span>
                  <span v-if="!row.dischargePermissionId">-</span>
                </td>
                <td style="width: 14%">
                  <span v-if="row.draftOrderId">{{ row.draftOrderId }}</span>
                  <span v-if="!row.draftOrderId">-</span>
                </td>
                <td style="width: 14%">
                  <span v-if="row.orderId">{{ row.orderId }}</span>
                  <span v-if="!row.orderId">-</span>
                </td>
                <td style="width: 14%">
                  {{ row.userName }}
                </td>
                <td style="width: 15%">
                  {{ row.description }}
                </td>
                <td style="width: 14%; direction: ltr">
                  {{ row.persianDateTime }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name:"basketManagement_ChannelBaskets_Events",
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {},
      gridSearchData: {},
      loaded: false,
    };
  },
  mounted() {
    var service =
      "Sales/api/BasketsQuery/" + this.$route.params.id + "/audit-trail";

    setTimeout(() => {
      this.gridDataSource = {
        type: "app",
        service: service,
      };
      this.loaded = true;
    }, 0);
  },
};
</script>

